export default "__VITE_ASSET__n8Sbclfq__"